import { Clipboard } from '@angular/cdk/clipboard';
import { DialogModule } from '@angular/cdk/dialog';
import { DatePipe, Location, NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { Article } from 'app/models/Article';
import { MarketData } from 'app/models/MarketData';
import { ThemeNews } from 'app/models/ThemeNews';
import { Utilisateur } from 'app/models/Utilisateur';
import { LinkService } from 'app/shared/Link.service';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { MetaService } from 'app/shared/meta.service';
import { ShareService } from 'app/shared/share.service';
import { SharedModule } from 'app/shared/shared.module';
import { SuiviService } from 'app/shared/suivi.service';
import { isToday } from 'app/utils/date.utils';
import { environment } from 'environments/environment';
import { Subject, Subscription } from 'rxjs';
import { ImageComponent } from '../../image/image.component';
import { NewsletterComponent } from '../newsletter/newsletter.component';
import { RecommendationArticleComponent } from '../recommendation-article/recommendation-article.component';
import { StatsCardsComponent } from '../stats-cards/stats-cards.component';
import { ArticleSchemaService } from 'app/shared/ArticleSchema.service';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgOptimizedImage,
        MatButtonModule,
        DialogModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule,
        SharedModule,
        DatePipe,
        MatPaginatorModule,
        MatTableModule,
        NewsletterComponent,
        RecommendationArticleComponent,
        ImageComponent,
        StatsCardsComponent,
        RouterModule
    ],
    providers: [DatePipe, ConvertToSlugPipe],
})
export class NewsComponent implements OnInit, OnDestroy {
    cloud_front = environment.cloud_front_host;
    ThemeNews = ThemeNews;
    serveur_name = environment.serveur_name;
    host_name = environment.host_name;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    idNews: string;
    news: Article;
    listeNews: Article[];
    imageNews: SafeUrl;
    watchlist: boolean = false;
    populaires: boolean = true;
    displayedColumns: string[] = ['Trouver un actif', 'Watchlist'];
    displayedColumns1: string[] = ['Trouver un actif', 'Watchlist'];
    public dataSource1 = new MatTableDataSource<MarketData>();
    public dataSource = new MatTableDataSource<MarketData>();
    user: Utilisateur;
    actifs: MarketData[] = [];
    showCheck: boolean = false;
    showSocials: boolean = false;
    html;
    newsRecommendees: Article[];
    isLogged: boolean;
    routeSub: Subscription;
    showCustom404 = false; 
    isSlugValid = true;  
    constructor(
        public location: Location,
        public shareService: ShareService,
        public suiviService: SuiviService,
        private seoService: LinkService,
        public dialog: MatDialog,
        private loginService: LoginService,
        private _changeDetectorRef: ChangeDetectorRef,
        private metaService: MetaService,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private sanitizer: DomSanitizer,        private router: Router,
        private clipboard: Clipboard,
        private convertToSlug: ConvertToSlugPipe,        private articleSchemaService: ArticleSchemaService
    ) {}
    yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
    formatDate(date): string {
        const created = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm');
        let fecha = new Date(created);
        let today = new Date();
        let yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(
            new Date()
        );

        if (isToday(today, fecha))
            return this.datePipe.transform(fecha, 'H:mm');
        if (isToday(yesterday, fecha)) return 'Hier';
        return this.datePipe.transform(fecha, 'd MMMM ');
    }

    ngOnInit() {

            this.routeSub = this.route.params.subscribe((params) => {
                this.idNews = params['id'];
                const [news, user] = this.route.snapshot.data['news']; // Destructuration corrigée
        
                this.news = news;
                this.user = user;
            this.newsRecommendees = this.route.snapshot.data['recommendations'];
                // Generate NewsArticle schema when article is valid
                this.articleSchemaService.generateNewsSchema(
                    this.news,
                    this.user
                );
                // Générer les schémas structurés
                this.articleSchemaService.generateGlobalWebPageSchema({
                    url:  environment.apiUrl +
                    '/actualites/news/' +
                    this.convertToSlug.transform(this.news.nom) +
                    '/' +
                    this.idNews,
                    name: this.news.nom,
                    description:this.news.description,
                    isPartOf: {
                        name: 'Irbe7',
                        url: environment.apiUrl,
                    },
                });
            
            this.metaService.updateMetaTags({
                title: this.news.nom,
                description: this.news.description,
                ogTitle: this.news.nom,
                ogType: 'article',
                ogUrl:
                    environment.apiUrl +
                    '/actualites/news/' +
                    this.convertToSlug.transform(this.news.nom) +
                    '/' +
                    this.idNews,
                ogDescription: this.news.description,
                ogImage: this.cloud_front + this.news.image,
                canonicalLink:
                    environment.apiUrl +
                    '/actualites/news/' +
                    this.convertToSlug.transform(this.news.nom) +
                    '/' +
                    this.idNews,
                twitterTitle: this.news.nom,
                twitterDescription: this.news.description,
                twitterImage: this.cloud_front + this.news.image,
                modifiedTime: this.news.date,
                publishedTime: this.news.date,
            });
            this.html = this.sanitizer.bypassSecurityTrustHtml(
                this.news.contenu
            );
            this._changeDetectorRef.markForCheck();
        });
        this.loginService;
        this.isLogged = this.loginService.getIsLogged();
        this.createLinkForCanonicalURL();

        //this.recupererWatchlist();

        // this.recupererPopulaires();
        //this.createLinkForCanonicalURL();
    }
    createLinkForCanonicalURL() {
        this.seoService.createLinkForCanonicalURL();
    }

    shareFacebook() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/news/' +
            this.convertToSlug.transform(this.news.nom) +
            '/' +
            this.idNews; // URL of the content to share
        this.shareService.shareOnFacebook(shareUrl);
    }
    shareLinkedin() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/news/' +
            this.convertToSlug.transform(this.news.nom) +
            '/' +
            this.idNews; // URL of the content to share
        this.shareService.shareOnLinkedIn(shareUrl);
    }
    copyClipboard() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/news/' +
            this.convertToSlug.transform(this.news.nom) +
            '/' +
            this.idNews;
        this.clipboard.copy(shareUrl);
        this.showCheck = true;
        setTimeout(() => {
            this.showCheck = false;
            this._changeDetectorRef.markForCheck();
        }, 1000);
    }

    retour() {
        this.location.back();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    masquerPopulaire() {
        if (this.populaires) {
            this.populaires = false;
        } else {
            this.populaires = true;
            this.watchlist = false;
        }
    }

    toggleShowSocials() {
        this.showSocials = !this.showSocials;
    }

    hideSocials() {
        this.showSocials = false;
    }
}
